<div fxLayout="column" *ngIf="listings">
    <h4>{listings.length, plural, =1 {1 property} other {{{listings.length}} properties}}</h4>

    <app-listing-by-member [listing]="listing" *ngFor="let listing of listings"></app-listing-by-member>
</div>
